import React, { useState } from 'react';
import './Pagination.css';

function Pagination({ page, totalPages, total, onPageChange }) {
  const [inputPage, setInputPage] = useState('');

  // Generate page numbers: current ± 5
  const getPageNumbers = () => {
    const pages = [];
    const start = Math.max(1, page - 10);
    const end = Math.min(totalPages, page + 10);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    const num = parseInt(inputPage, 10);
    if (num >= 1 && num <= totalPages) {
      onPageChange(num);
      setInputPage('');
    }
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="pg-bar">
      {/* İlk sayfa */}
      <button
        className="pg-btn pg-nav"
        disabled={page <= 1}
        onClick={() => onPageChange(1)}
        title="İlk Sayfa"
      >⟪</button>

      {/* Önceki */}
      <button
        className="pg-btn pg-nav"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        title="Önceki Sayfa"
      >◀</button>

      {/* Sayfa numaraları */}
      <div className="pg-numbers">
        {pageNumbers.map(p => (
          <button
            key={p}
            className={`pg-btn pg-num ${p === page ? 'pg-active' : ''}`}
            onClick={() => onPageChange(p)}
          >{p}</button>
        ))}
      </div>

      {/* Sonraki */}
      <button
        className="pg-btn pg-nav"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        title="Sonraki Sayfa"
      >▶</button>

      {/* Son sayfa */}
      <button
        className="pg-btn pg-nav"
        disabled={page >= totalPages}
        onClick={() => onPageChange(totalPages)}
        title="Son Sayfa"
      >⟫</button>

      {/* Sayfa giriş */}
      <form className="pg-input-form" onSubmit={handleInputSubmit}>
        <input
          type="number"
          className="pg-input"
          placeholder="Sayfa"
          min={1}
          max={totalPages}
          value={inputPage}
          onChange={e => setInputPage(e.target.value)}
        />
        <button type="submit" className="pg-go-btn">Git</button>
      </form>

      {/* Toplam bilgi */}
      <span className="pg-info">
        {page}/{totalPages}
        <span className="pg-total">({total} kayıt)</span>
      </span>
    </div>
  );
}

export default Pagination;
